import { persistedExchange } from "@urql/exchange-persisted"
import { invert } from "es-toolkit"
import signaturesToQueries from "../../gen/persisted-documents.json" with {
  type: "json",
}

const queriesToSignature = invert(signaturesToQueries)

export const getQuerySignature = async (query: string) => {
  return queriesToSignature[query]
}

export const apqExchange = persistedExchange({
  generateHash: query => getQuerySignature(query),
  preferGetForPersistedQueries: false,
})
